<h6 class="s1 col-1 m-t">{{sectionTitle}}</h6>
<div class="m-t-2">
    <ng-content></ng-content>
</div>